import React from 'react';

const PRLoader = () => {
  return (
    <div className="flex flex--column gap-1 pr-loader w-5 h-4 relative">
      {[1,2,3].map((index) => (
        <div className={"pr-loader__item gap-05 flex flex--center absolute left-0 w-full pr-loader__item--" + index} key={index}>
          <div className="pr-loader__block bg-white"></div>
          <div className="flex flex--column flex--center flex--top flex--1">
            <div className="pr-loader__line pr-loader__line--1 bg-white"></div>
            <div className="pr-loader__line pr-loader__line--2 bg-white"></div>
          </div>
        </div>
      ))}
    </div>
  )
};

export default PRLoader
